<template id="map-template">
  <div>
    <zj-layout-container>
      <zj-layout-main>
        <div class="map-root select-none">
          <MapView ref="regionMap" MapKey="LightMap"></MapView>
          <div class="right-side">
            <div class="right-side-wrapper">
              <div class="right-side-1">
                <div class="content-wrapper">
                  <EquipRightPanel
                    :deviceList="lightEquipmentList"
                    :logList="logList"
                    :equipmentList="equipmentList"
                  ></EquipRightPanel>
                </div>
              </div>
            </div>
          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
import { getEquipmentCode, listEquipment } from "@/api/src/equipment";
import { listWarnRecord } from "@/api/src/warnMessage";

export default {
  name: "LightView",
  componentName: "LightView",

  // 可接收 URL 参数。
  // 仅当通过 url 跳转的时候可接收这些参数。
  // 也可通过 this.$route.query 来查询 url 参数。
  props: {},
  data() {
    return {
      loading: false,

      //预警日志
      logList: [],
      //设备信息
      lightEquipmentList: [],
      equipmentList: [],
    };
  },
  methods: {
    // 获取设备code
    init() {
      getEquipmentCode("lightEquipment").then((response) => {
        this.code = response.data;
        this.getList();
        this.getLogList();
      });
    },
    // 查询
    getList() {
      this.loading = true;

      listEquipment({ categoryCode: this.code, pageSize: 10000 }).then(
        (response) => {
          this.lightEquipmentList = [];
          let list = response.rows;
          this.equipmentList = list;
          this.total = response.total;
          //故障数
          let exceptionCount = list.filter(function (item) {
            return item.onlineStatus == 2 || item.onlineStatus == null;
          }).length;
          //在线状态 1 点亮  2 故障
          let activeCount = list.filter(function (item) {
            return item.onlineStatus == 1;
          }).length;
          this.lightEquipmentList = [
            {
              Name: "路灯",
              Count: this.total || 0,
            },
            {
              Name: "点亮",
              Count: activeCount || 0,
            },
            {
              Name: "故障",
              Count: exceptionCount || 0,
            },
          ];

          this.loading = false;
        }
      );
    },
    //获取报警日志
    getLogList() {
      listWarnRecord({ categoryCode: this.code, pageSize: 10000 }).then(
        (response) => {
          this.logList = response.rows;
        }
      );
    },
  },
  mounted() {
    this.init();
    this.logInfo.ActionName = "灯控设备概览";
    this.logInfo.LogMessage = "灯控设备概览";
    this.logInfo.ModuleName = "智能控制";
    this.logInfo.PageName = "灯控设备概览页";
    this.addOperationLog();
  },
  beforeDestroy() {},
  destroyed() {},
  controller: "UI",
  action: "LightView",
};
</script>

<style scoped>
.zj-vehicleview-root {
  height: 100%;
  width: 100%;
  position: relative;
}
</style>
